const MiB = 1024 * 1024;

/** Chunk layout for new direct/presigned sessions. Backend transport stays unchanged. */
export function directUploadChunkBytes(size: number): number {
  if (!Number.isSafeInteger(size) || size < 1) throw new RangeError('Invalid upload size');
  return size <= 80 * MiB ? 5 * MiB : 32 * MiB;
}

/** Existing sessions without chunkBytes retain their original 5 MiB layout. */
export function directSessionChunkBytes(session: { chunkBytes?: number }): number {
  const value = session.chunkBytes ?? 5 * MiB;
  if (value !== 5 * MiB && value !== 32 * MiB) throw new RangeError('Invalid session chunk size');
  return value;
}
